import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { registerUser } from "../../../states/actions/userAction";
import { useTranslation } from "react-i18next";
import Logo from "../../../assets/images/logo/LawLogo2-removebg-preview.png";

const Signup = () => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setPassword(e.target.value);
    const validationError = validatePassword(e.target.value);
    setError(validationError);
  };
  const validatePassword = (password) => {
    const minLength = /(?=.{8,})/; // At least 8 characters
    const hasUpperCase = /(?=.*[A-Z])/; // At least one uppercase letter
    const hasLowerCase = /(?=.*[a-z])/; // At least one lowercase letter
    const hasDigit = /(?=.*\d)/; // At least one digit
    const hasSpecialChar = /(?=.*[@#$%^&+=])/; // At least one special character

    if (!minLength.test(password)) {
      return "Password must be at least 8 characters long";
    }
    if (!hasUpperCase.test(password)) {
      return "Password must contain at least one uppercase letter";
    }
    if (!hasLowerCase.test(password)) {
      return "Password must contain at least one lowercase letter";
    }
    if (!hasDigit.test(password)) {
      return "Password must contain at least one digit";
    }
    if (!hasSpecialChar.test(password)) {
      return "Password must contain at least one special character";
    }

    return null; // Valid password
  };

  const onSubmit = (UserData) => {
    const newData = {
      ...UserData,
      role: "user",
    };
    const validationError = validatePassword(UserData.password);
    if (validationError) {
      setError(validationError);
    } else {
      // dispatch
      dispatch(registerUser(newData)).then((response) => {
        if (response?.meta?.requestStatus === "fulfilled") {
          setTimeout(function () {
            navigate("/login");
          }, 5000);
        } else {
          setError("Registration failed. Please try again.");
        }
      });
    }
  };
  // State to toggle password visibility
  const [showPassword, setShowPassword] = useState(false);

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };
  const { t: translate } = useTranslation(["loginAndregister"]);
  return (
    <>
      <div class="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
        <div class="w-full max-w-sm p-6 m-auto bg-white rounded-lg shadow-md dark:bg-gray-800">
          <div class="flex justify-center mx-auto">
            <img class="w-auto h-9 sm:h-10" src={Logo} alt="" />
          </div>

          <p class="mt-3 text-xl text-center text-gray-600 dark:text-gray-200">
            ጠበቃ አደራው አዲሱ!
          </p>

          <a
            href="#"
            class="flex items-center justify-center mt-4 text-gray-600 transition-colors duration-300 transform border rounded-lg dark:border-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-600"
          >
            <div class="px-4 py-2">
              <svg class="w-6 h-6" viewBox="0 0 40 40">
                <path
                  d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.045 27.2142 24.3525 30 20 30C14.4775 30 10 25.5225 10 20C10 14.4775 14.4775 9.99999 20 9.99999C22.5492 9.99999 24.8683 10.9617 26.6342 12.5325L31.3483 7.81833C28.3717 5.04416 24.39 3.33333 20 3.33333C10.7958 3.33333 3.33335 10.7958 3.33335 20C3.33335 29.2042 10.7958 36.6667 20 36.6667C29.2042 36.6667 36.6667 29.2042 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z"
                  fill="#FFC107"
                />
                <path
                  d="M5.25497 12.2425L10.7308 16.2583C12.2125 12.59 15.8008 9.99999 20 9.99999C22.5491 9.99999 24.8683 10.9617 26.6341 12.5325L31.3483 7.81833C28.3716 5.04416 24.39 3.33333 20 3.33333C13.5983 3.33333 8.04663 6.94749 5.25497 12.2425Z"
                  fill="#FF3D00"
                />
                <path
                  d="M20 36.6667C24.305 36.6667 28.2167 35.0192 31.1742 32.34L26.0159 27.975C24.3425 29.2425 22.2625 30 20 30C15.665 30 11.9842 27.2359 10.5975 23.3784L5.16254 27.5659C7.92087 32.9634 13.5225 36.6667 20 36.6667Z"
                  fill="#4CAF50"
                />
                <path
                  d="M36.3425 16.7358H35V16.6667H20V23.3333H29.4192C28.7592 25.1975 27.56 26.805 26.0133 27.9758C26.0142 27.975 26.015 27.975 26.0158 27.9742L31.1742 32.3392C30.8092 32.6708 36.6667 28.3333 36.6667 20C36.6667 18.8825 36.5517 17.7917 36.3425 16.7358Z"
                  fill="#1976D2"
                />
              </svg>
            </div>

            <span class="w-5/6 px-4 py-3 font-bold text-center">
              Sign up with Google
            </span>
          </a>

          <div class="flex items-center justify-between mt-4">
            <span class="w-1/5 border-b dark:border-gray-600 lg:w-1/4"></span>

            <a
              href="#"
              class="text-xs text-center text-gray-500 uppercase dark:text-gray-400 hover:underline"
            >
              or login with email
            </a>

            <span class="w-1/5 border-b dark:border-gray-400 lg:w-1/4"></span>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div class="mt-4">
              <label class="block mb-2 text-sm font-medium text-gray-600 dark:text-gray-200">
                Full Name
              </label>
              <input
                class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="text"
                {...register(`firstName`, {
                  required: true,
                  maxLength: 1000,
                  pattern: /^[A-Za-z\s]+$/,
                })}
              />
              {errors.firstName && (
                <p className="text-red-500">full name is not Valide</p>
              )}
            </div>
            <div class="mt-4">
              <label class="block mb-2 text-sm font-medium text-gray-600 dark:text-gray-200">
                Email Address
              </label>
              <input
                class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                type="email"
                {...register(`email`, {
                  required: true,
                  pattern:
                    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
                })}
              />
              {errors.email && <p className="text-red-500">Email is invalid</p>}
            </div>

            <div class="mt-4">
              <div class="flex justify-between">
                <label class="block mb-2 text-sm font-medium text-gray-600 dark:text-gray-200">
                  Password
                </label>
                <a
                  href="#"
                  class="text-xs text-gray-500 dark:text-gray-300 hover:underline"
                >
                  terms and policy?
                </a>
              </div>
              <div class="relative flex items-center">
                <input
                  class="block w-full px-4 py-2 text-gray-700 bg-white border rounded-lg dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300"
                  //type="password"
                  type={showPassword ? "text" : "password"}
                  {...register("password", {})}
                  onChange={handleChange}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#bbb"
                  stroke="#bbb"
                  class="w-4 h-4 absolute right-4 cursor-pointer"
                  viewBox="0 0 128 128"
                  onClick={togglePasswordVisibility}
                >
                  <path
                    d="M64 104C22.127 104 1.367 67.496.504 65.943a4 4 0 0 1 0-3.887C1.367 60.504 22.127 24 64 24s62.633 36.504 63.496 38.057a4 4 0 0 1 0 3.887C126.633 67.496 105.873 104 64 104zM8.707 63.994C13.465 71.205 32.146 96 64 96c31.955 0 50.553-24.775 55.293-31.994C114.535 56.795 95.854 32 64 32 32.045 32 13.447 56.775 8.707 63.994zM64 88c-13.234 0-24-10.766-24-24s10.766-24 24-24 24 10.766 24 24-10.766 24-24 24zm0-40c-8.822 0-16 7.178-16 16s7.178 16 16 16 16-7.178 16-16-7.178-16-16-16z"
                    data-original="#000000"
                  ></path>
                </svg>
              </div>
              {error && <p style={{ color: "red" }}>{error}</p>}
            </div>

            <div class="mt-6">
              <button
                type="submit"
                class="w-full px-6 py-3 text-sm font-medium tracking-wide text-white capitalize transition-colors duration-300 transform bg-[#6C4E3C] rounded-lg hover:bg-[#453023] focus:outline-none focus:ring focus:ring-gray-300 focus:ring-opacity-50"
              >
                Sign Up
              </button>
            </div>
          </form>
          <div class="flex items-center justify-between mt-4">
            <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>

            <a
              href="/login"
              class="text-xs text-gray-500 uppercase dark:text-gray-400 hover:underline"
            >
              or sign in
            </a>

            <span class="w-1/5 border-b dark:border-gray-600 md:w-1/4"></span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
